import React from 'react';
import learningCenterIdentifier from 'utils/learning-center-identifier';
import { Link } from 'react-router-dom';
import ClampLines from 'react-clamp-lines';
import Card from 'components/shared/card';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const LearningCenter = ({
  center,
  name,
  credentials,
  title,
  leaderPicture,
  description,
  location,
  subjects,
  noLink,
  linkPrefix,
}) => (
  <Card>
    <div className={styles.learningCenter}>
      <div className={styles.mainRow}>
        <div className={styles.secondaryColumn}>
          <img src={leaderPicture} />
          <div className={styles.leaderMeta}>
            <div className={styles.leader}>
              <h2>{name}</h2>
              <h4>{location}</h4>
            </div>
            <div className={styles.credentials}>
              <h5>Education &amp; Credentials</h5>
              <ul className="list-unstyled">
                {credentials.map(cred => (
                  <li key={cred}>{cred}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className={styles.mainColumn}>
          <Link to={`${linkPrefix}/${learningCenterIdentifier(center)}`}>
            <h3>{title}</h3>
          </Link>
          <ClampLines
            id="learning-center-description"
            text={description}
            lines={4}
            tagName="p"
            buttons={false}
          />
          <div className={styles.subjectSection}>
            <h4>Subjects</h4>
            <div className={styles.subjectList}>
              {subjects.map(subject => (
                <div className={styles.subject} key={subject}>
                  {subject}
                </div>
              ))}
            </div>
          </div>
          <div className={styles.learningCenterCta}>
            {!noLink && (
              <Link
                to={`${linkPrefix}/${learningCenterIdentifier(center)}`}
                className="button apple lg"
              >
                See details
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  </Card>
);

LearningCenter.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  leaderPicture: PropTypes.string,
  professionalTitle: PropTypes.string,
  description: PropTypes.string,
  location: PropTypes.string,
  subjects: PropTypes.arrayOf(PropTypes.string),
  capacityMessage: PropTypes.string,
};

export default LearningCenter;
